import React, { useState, useEffect } from 'react';
import { X, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { useLang } from '../context/LanguageContext';

const CookieBanner = ({ onShowPrivacy }) => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLang();
  const [textPre, textPost] = t('cookie.text').split('{privacy}');

  useEffect(() => {
    // Check if user has already accepted
    const hasAccepted = localStorage.getItem('invictaflow_privacy_accepted');
    if (!hasAccepted) {
      // Show banner after a short delay
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('invictaflow_privacy_accepted', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('invictaflow_privacy_accepted', 'false');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-6 animate-in slide-in-from-bottom duration-300">
      <div className="max-w-6xl mx-auto bg-white rounded-3xl shadow-2xl border border-[#D2D2D7] p-6">
        <div className="flex items-start gap-4">
          <div className="bg-[#0071E3]/10 rounded-2xl p-3 flex-shrink-0">
            <Shield className="w-6 h-6 text-[#0071E3]" />
          </div>
          
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-[#1D1D1F] mb-2">
              {t('cookie.title')}
            </h3>
            <p className="text-[#86868B] text-sm mb-4">
              {textPre}
              <button
                onClick={() => {
                  onShowPrivacy();
                  setIsVisible(false);
                }}
                className="text-[#0071E3] hover:underline font-medium"
              >
                {t('cookie.privacyLink')}
              </button>
              {textPost}
            </p>
            
            <div className="flex flex-wrap gap-3">
              <Button
                onClick={handleAccept}
                className="bg-[#0071E3] hover:bg-[#0077ED] text-white rounded-full px-6 h-10"
              >
                {t('cookie.acceptAll')}
              </Button>
              <Button
                onClick={handleDecline}
                variant="outline"
                className="border-[#D2D2D7] text-[#86868B] hover:text-[#1D1D1F] hover:bg-[#F5F5F7] rounded-full px-6 h-10"
              >
                {t('cookie.necessary')}
              </Button>
              <button
                onClick={() => {
                  onShowPrivacy();
                  setIsVisible(false);
                }}
                className="text-[#86868B] hover:text-[#0071E3] text-sm px-4"
              >
                {t('cookie.learnMore')}
              </button>
            </div>
          </div>
          
          <button
            onClick={() => setIsVisible(false)}
            className="text-[#86868B] hover:text-[#1D1D1F] flex-shrink-0"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
